import React, {Component} from 'react';
import ClientsFixedDataTable from '../components/ClientsFixedDataTable';

export default class Clients extends Component {

	constructor(props){
		super(props);
		var defaultSearch = {
            page: 1,
            searchText: '',
            perPage : 100
        };

        var search = JSON.parse(localStorage.getItem('lastClientSearch')) || defaultSearch;
        this.state = {
        	search : search
        };
	}

	handleFilterChange(searchQuery){
		localStorage.setItem('lastClientSearch', JSON.stringify(searchQuery));
	}

    render() {    	

        return (
            <div className="col-md-12">
            	<h1>All Clients</h1>
            	<ClientsFixedDataTable defaultSearch={this.state.search} handleFilterChange={this.handleFilterChange.bind(this)} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/pages/Clients.js